var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"case-tabs"},[_c('div',{class:['case-tab', _vm.current_tab == 'Sifarnik' ? 'active' : '' ],on:{"click":function($event){return _vm.changeView('sifarnik')}}},[_vm._v(" Šifarnici ")])])])}
var staticRenderFns = []

export { render, staticRenderFns }